import type { QuizSingleStep } from "@/types/api.types";

type GraphProps = {
  step?: QuizSingleStep;
  currentWeight: string;
  goalWeight: string;
  gradientStart?: string;
  gradientEnd?: string;
  showRedLine?: boolean;
};

const Graph = ({
  step,
  currentWeight,
  goalWeight,
  showRedLine = true,
  gradientStart,
  gradientEnd,
}: GraphProps) => {
  return (
    <div className="flex justify-center pt-10">
      <div className="w-full max-w-[600px]">
        {/* Keeps the correct scaling */}
        <svg
          className="w-full h-auto overflow-visible"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 600 176"
          fill="none"
          preserveAspectRatio="xMidYMid meet"
        >
          {/* Background fill */}
          <path
            d="M201.347 22.2495C123.232 -6.03328 0 0.700729 0 0.700729V175.084H600V132.687C499.636 131.897 462.626 136.7 365.657 94.9495C268.687 53.1987 279.461 50.5324 201.347 22.2495Z"
            fill="url(#paint0_linear)"
          />

          {/* Red line */}
          {showRedLine && (
            <path
              d="M2.69336 2.6936C2.69336 2.6936 95.8395 2.69375 167.186 46.1959C238.532 89.698 288.077 20.828 369.828 46.1959C451.579 71.5637 468.424 104.467 600 46.1957"
              stroke="#FF5F7E"
              strokeWidth="5.38721"
              strokeLinecap="round"
            />
          )}

          {/* Blue line */}
          <path
            d="M0.144531 3.39433C0.144531 3.39433 123.377 -3.33968 201.491 24.9432C279.606 53.226 268.831 55.8923 365.801 97.6431C462.771 139.394 499.781 134.59 600.145 135.381"
            stroke="#248AFF"
            strokeWidth="5.38721"
          />

          {/* LEFT dot + label */}
          <g transform="translate(48 5)">
            {/* label pill above dot */}
            <g transform="translate(-34 -45)">
              <rect width="74" height="30" rx="4" fill="#FFA503" />
              <text
                x="37"
                y="22"
                textAnchor="middle"
                fontSize="20"
                fontWeight="600"
                fill="black"
              >
                {currentWeight}
              </text>
            </g>

            {/* dot */}
            <circle
              cx="0"
              cy="0"
              r="7"
              fill="#FFA503"
              stroke="white"
              strokeWidth="2"
            />
          </g>

          {/* RIGHT dot + label */}
          <g transform="translate(552 134)">
            {/* label pill above dot */}
            <g transform="translate(-34 -45)">
              <rect width="74" height="30" rx="4" fill="#FFA503" />
              <text
                x="37"
                y="22"
                textAnchor="middle"
                fontSize="20"
                fontWeight="600"
                fill="black"
              >
                {goalWeight}
              </text>
            </g>

            {/* dot */}
            <circle
              cx="0"
              cy="0"
              r="7"
              fill="#FFA503"
              stroke="white"
              strokeWidth="2"
            />
          </g>

          {/* defs */}
          <defs>
            <linearGradient
              id="paint0_linear"
              gradientUnits="userSpaceOnUse"
              x1="0"
              y1="0"
              x2="600"
              y2="0"
            >
              <stop offset="0%" stopColor={gradientStart ?? "#BDE2FF"} />
              <stop offset="100%" stopColor={gradientEnd ?? "#FFFFFF"} />
            </linearGradient>
          </defs>
        </svg>

        {showRedLine && (
          <div className="flex flex-row items-center mx-auto pt-6 justify-center gap-6">
            <div className="flex flex-row items-center gap-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="4"
                viewBox="0 0 30 4"
                fill="none"
              >
                <path
                  d="M28 0C29.1046 0 30 0.89543 30 2C30 3.10457 29.1046 4 28 4H2C0.89543 4 0 3.10457 0 2C0 0.89543 0.89543 0 2 0H28Z"
                  fill="#248AFF"
                />
              </svg>
              <span className="text-[16px] leading-none text-[#333]">
                {step?.legendLabelWithProduct}
              </span>
            </div>
            <div className="flex flex-row items-center gap-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="4"
                viewBox="0 0 30 4"
                fill="none"
              >
                <path
                  d="M28 0C29.1046 0 30 0.89543 30 2C30 3.10457 29.1046 4 28 4H2C0.89543 4 0 3.10457 0 2C0 0.89543 0.89543 0 2 0H28Z"
                  fill="#FF5F7E"
                />
              </svg>
              <span className="text-[16px] leading-none text-[#333]">
                {step?.legendLabelWithoutProduct}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Graph;
